export const updateOrgForm = (formik, field, newValue) => {
  let Country = newValue?.Place?.Country || "";
  let Region = newValue?.Place?.Region || "";
  let Municipality = newValue?.Place?.Municipality || "";
  let PostalCode = newValue?.Place.PostalCode?.split(" ")[0] || "";
  let SubRegion = newValue?.Place.SubRegion || "";
  let Street = newValue?.Place.Street || "";
  let AddressNumber = newValue?.Place.AddressNumber || "";

  if (field === "address_line_1") {
    if (Street !== "" && AddressNumber !== "") {
      formik.setFieldValue("address_line_1", `${AddressNumber} ${Street}`);
      formik.setFieldValue("city", Municipality);
      formik.setFieldValue("state", Region);
      formik.setFieldValue("postal_code", newValue?.Place.PostalCode);
      return;
    }
    let suggestedValue = newValue?.Place?.Label.split(", ")
      ?.filter((item) => {
        return (
          item
            .toLocaleLowerCase()
            .trim()
            .indexOf(Municipality.toLocaleLowerCase().trim()) === -1 &&
          item
            .toLocaleLowerCase()
            .trim()
            .indexOf(Country.toLocaleLowerCase().trim()) === -1 &&
          item
            .toLocaleLowerCase()
            .trim()
            .indexOf(Region.toLocaleLowerCase().trim()) === -1 &&
          item
            .toLocaleLowerCase()
            .trim()
            .indexOf(PostalCode.toLocaleLowerCase().trim()) === -1 &&
          item
            .toLocaleLowerCase()
            .trim()
            .indexOf(SubRegion.toLocaleLowerCase().trim()) === -1
        );
      })
      .join(", ");
    if (Street) {
      suggestedValue = `${suggestedValue?.split(Street)[0]}${Street}`;
    }
    formik.setFieldValue(field, suggestedValue);
  } else if (field === "city" && Municipality !== "") {
    formik.setFieldValue("city", Municipality);
  } else if (field === "state" && Region !== "") {
    formik.setFieldValue("state", Region);
  } else if (field === "postal_code" && PostalCode !== "") {
    formik.setFieldValue("postal_code", newValue?.Place.PostalCode);
  } else if (field === "shipping_address_line_1") {
    if (Street !== "" && AddressNumber !== "") {
      formik.setFieldValue(
        "shipping_address_line_1",
        `${AddressNumber} ${Street}`
      );
      formik.setFieldValue("shipping_city", Municipality);
      formik.setFieldValue("shipping_state", Region);
      formik.setFieldValue("shipping_postal_code", newValue?.Place.PostalCode);
      return;
    }
    let suggestedValue = newValue?.Place?.Label.split(", ")
      ?.filter((item) => {
        return (
          item
            .toLocaleLowerCase()
            .trim()
            .indexOf(Municipality.toLocaleLowerCase().trim()) === -1 &&
          item
            .toLocaleLowerCase()
            .trim()
            .indexOf(Country.toLocaleLowerCase().trim()) === -1 &&
          item
            .toLocaleLowerCase()
            .trim()
            .indexOf(Region.toLocaleLowerCase().trim()) === -1 &&
          item
            .toLocaleLowerCase()
            .trim()
            .indexOf(PostalCode.toLocaleLowerCase().trim()) === -1 &&
          item
            .toLocaleLowerCase()
            .trim()
            .indexOf(SubRegion.toLocaleLowerCase().trim()) === -1
        );
      })
      .join(", ");
    if (Street) {
      suggestedValue = `${suggestedValue?.split(Street)[0]}${Street}`;
    }
    formik.setFieldValue(field, suggestedValue);
  } else if (field === "shipping_city" && Municipality !== "") {
    formik.setFieldValue("shipping_city", Municipality);
  } else if (field === "shipping_state" && Region !== "") {
    formik.setFieldValue("shipping_state", Region);
  } else if (field === "shipping_postal_code" && PostalCode !== "") {
    formik.setFieldValue("shipping_postal_code", newValue?.Place.PostalCode);
  } else {
    formik.setFieldValue(field, newValue?.Place?.Label || "");
  }
};
